module.exports = __webpack_public_path__ + "img/vehicle-options-black-mitsu.f6d02423.png";